import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';

import AssetSummaryTray from '@atom/components/mapPortal/assetSummary/AssetSummaryTray';
import { GET_ASSET } from '@atom/graph/asset';
import client from '@atom/graph/client';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import api from '@atom/utilities/api';
import { INVENTORY_ASSETS_ENDPOINT } from '@atom/utilities/endpoints';

import { useWorkOrdersData } from '../hooks/workOrdersDataHook';

const AssetSummaryWrapper = () => {
  const [searchParamsObject, { updateSearchParams }] = useNavigation({
    id: SearchParamType.STRING,
    view: SearchParamType.STRING,
  });

  const id: string = searchParamsObject?.id;

  const [loadingRename, setLoadingRename] = useState<boolean>(false);

  const [getAsset, { loading: assetLoading, data, refetch }] = useLazyQuery(
    GET_ASSET,
    {
      fetchPolicy: 'no-cache',
    },
  );

  const [workOrders, workOrdersLoading] = useWorkOrdersData({
    assetId: id,
    statusIds: '0,1,2,3,4,5',
    sortBy: 'status',
  });

  useEffect(() => {
    if (!id.includes(',')) {
      getAsset({ variables: { id } });
    }
  }, [id]);

  const renameInventory = async (name: string) => {
    setLoadingRename(true);

    await api.patch(`${INVENTORY_ASSETS_ENDPOINT}/${id}`, { name });

    client.cache.modify({
      id: client.cache.identify(data.asset),
      fields: {
        name: () => name,
      },
    });

    setLoadingRename(false);
  };

  const onCancel = () => {
    updateSearchParams({ view: 'list', id: null });
  };

  const loading = (assetLoading && workOrdersLoading) || !data;

  return (
    <AssetSummaryTray
      asset={data?.asset}
      refetch={refetch}
      loading={loading}
      loadingRename={loadingRename}
      workOrders={workOrders}
      renameInventory={renameInventory}
      onCancel={onCancel}
    />
  );
};

export default AssetSummaryWrapper;
